<div class="container marginMobile mb-5">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-4 col-xl-2">
            <app-dashmenu></app-dashmenu>
          </div>
          <div class="col-12 col-md-8 col-lg-8 col-xl-10">
            <div class="card">
              <div class="card-body py-4">
                <div class="row g-3 mesInfos">
                  <div class="col-md-12">
                    <h3 class="my-3 titleDevider">Vos identifiants</h3>
                  </div>
                  <div class="col-md-4">
                    <label for="email"  class="form-label">Email</label><br/>
                    <span>{{profile.email}}</span>
                  </div>
                  <!-- <div class="col-md-4">
                    <label for="confirmEmail" class="form-label">Email Confirmation</label>
                    <input type="email" class="form-control" id="confirmEmail">
                  </div>-->
                  <!-- <div class="col-md-4">
                    <label for="password" class="form-label">Mot de passe</label>
                    <input type="password" class="form-control" id="password">
                  </div> -->
                  <div class="col-md-12">
                    <h3 class="my-3 titleDevider">Vos informations personnelles</h3>
                  </div>
                  <!-- <div class="col-4">
                    <label class="form-label d-block">Vous êtes :</label>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="etatUtilisateur" id="particulier" value="particulier">
                      <label class="form-check-label" for="particulier">Particulier</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input"  type="radio" name="etatUtilisateur" id="societe" value="societe">
                      <label class="form-check-label" for="societe">Société</label>
                    </div>
                  </div> -->
                  <div class="col-md-4">
                    <label for="raisonsocial" class="form-label">Raison Sociale * :</label><br/>
                    <span>{{profile.raisonSociale}}</span>
                  </div>
                  <div class="col-md-4">
                    <label for="ice" class="form-label">ICE * :</label><br/>
                    <span>{{profile.ice}}</span>
                  </div>
                  <div class="col-md-12">
                    <h3 class="my-3 titleDevider">Vos coordonnées téléphoniques</h3>
                  </div>
                  <div class="col-md-4">
                    <label for="telephone" class="form-label">Téléphone mobile * :</label><br/>
                    <span>{{profile.tel}}</span>
                  </div>
                  <div class="col-md-12">
                    <h3 class="my-3 titleDevider">Vos coordonnées</h3>
                  </div>
                  <div class="col-12">
                    <label for="adresse" class="form-label">Adresse</label><br/>
                    <span>{{profile.adresse}}</span>
                  </div>
                  <!-- <div class="col-md-4">
                    <label for="address2" class="form-label">Complément d'adresse</label>
                    <input type="text" class="form-control" id="address2">
                  </div> -->
                  <div class="col-md-5">
                    <label for="inputCity" class="form-label">Ville</label><br/>
                    <span>{{profile.ville}}</span>
                  </div>
                  <!-- <div class="col-md-3">
                    <label for="inputZip" class="form-label">Code Postale</label>
                    <input type="text" class="form-control" id="inputZip">
                  </div>
                  <div class="col-12 text-end mt-5">
                    <button type="submit" class="btn actionBtn" style="width:auto;">Confirmer les changements</button>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="card mt-4">
              <div class="card-body py-4">

                <h3 class="my-3 titleDevider">Changement mot de passe</h3>
                <div class="alert alert-success" *ngIf="success" role="alert">
                    Votre mot de passe a bien été modifié
                </div>
                <div class="alert alert-danger" *ngIf="errorMatching" role="alert">
                    Les mots de passe saisis ne sont pas identiques!
                </div>
                <div class="alert alert-danger" *ngIf="errorRequis" role="alert">
                    Tous les champs sont requis!
                </div>
                <div class="col-md-12">
                  <label for="password" class="form-label">Mot de passe</label>
                  <input type="password" class="form-control" [(ngModel)]="pwd" id="password">
                </div>
                <div class="col-md-12 mt-4">
                  <label for="password" class="form-label">Confirmer Mot de passe</label>
                  <input type="password" class="form-control" [(ngModel)]="cPwd" id="password">
                </div>
                <div class="col-md-12 mt-4">
                       <button (click)="changePwd()" type="button" class="generatePDF" name="button">
                         <i class="fa fa-save" aria-hidden="true"></i> Enregister
                       </button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
